import { CheckIcon, toolkitCx } from "@sundae/ui-toolkit";
import cx from "classnames";
import { FC } from "react";
import { testIds } from "../../constants/testIds.constants";
import { TPool } from "../../types/Pool.types";
import PoolComponent from "../PoolComponent";
import { IPoolComponentProps } from "../PoolComponent/PoolComponent";

interface IPoolPickerItemProps {
  isSelected: boolean;
  onPoolSelect: (pool: TPool) => void;
  poolComponentProps: IPoolComponentProps;
  pool: TPool;
}

const PoolPickerItem: FC<IPoolPickerItemProps> = ({
  isSelected,
  onPoolSelect,
  poolComponentProps,
  pool,
}) => {
  return (
    <li
      className={cx(
        "group flex cursor-pointer items-center gap-3 p-4 pl-8 will-change-transform hover:bg-primary/20",
        toolkitCx.layout.transition.colors,
        {
          "bg-primary/10": isSelected,
        }
      )}
      key={pool.ident}
      onClick={() => onPoolSelect(pool)}
      data-testid={`${testIds.exchangeFlow.orderControls.liquidityPoolDropdown.item}-${pool.ident}`}
      role="option"
    >
      {isSelected && (
        <CheckIcon
          className={cx("absolute left-2 h-4 w-4 text-primary", toolkitCx.recipes.center.vertical)}
        />
      )}
      <PoolComponent {...poolComponentProps} pool={pool} />
    </li>
  );
};

export default PoolPickerItem;
